import { IConsistencyCheckRanFilter } from '@interfaces/cmModule/dto/consistencyCheckDTO';

import { EMenuActionsTypes } from '@enums/common';

export const getAssignConsistencyCheckOptions = (
	isIdsLength?: boolean,
	isNonFilterEmpty?: boolean,
) => [
	{
		id: EMenuActionsTypes.selected,
		text: 'Selected on current page',
		disabled: !isIdsLength,
	},
	{
		id: EMenuActionsTypes.currentPage,
		text: 'Current page',
		disabled: false,
	},
	{
		id: EMenuActionsTypes.all,
		text: 'All',
		disabled: false,
	},
	{
		id: EMenuActionsTypes.allFiltered,
		text: 'All filtered',
		disabled: !isNonFilterEmpty,
	},
];

export const getAssignTemplateDTO = ({
	actionId,
	currentPageIds,
	selectedIds,
	filter,
}:{
	actionId: string;
	currentPageIds?: string[];
	selectedIds?: string[];
	filter?: IConsistencyCheckRanFilter;
}) => {
	switch (actionId) {
		case EMenuActionsTypes.all:
			return {
				isAll: true,
				ids: [],
				filter: undefined,
			};
		case EMenuActionsTypes.currentPage:
			return {
				isAll: false,
				ids: currentPageIds,
				filter: undefined,
			};
		case EMenuActionsTypes.selected:
			return {
				isAll: false,
				ids: selectedIds,
				filter: undefined,
			};
		case EMenuActionsTypes.allFiltered:
			return {
				isAll: true,
				ids: selectedIds,
				filter,
			};
		default:
			return;
	}
};
